import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const CoverImage = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.75 4.10526C2.75 3.32006 3.34543 2.75 4 2.75H16C16.6546 2.75 17.25 3.32006 17.25 4.10526V9.25H15.5681L12.2907 4.33397C12.1524 4.12656 11.9201 4.0014 11.6709 4.00001C11.4216 3.99862 11.1879 4.12117 11.0473 4.32703L9.51931 6.56446L8.48809 5.68056C8.33707 5.55111 8.1408 5.48695 7.94248 5.50221C7.74415 5.51747 7.56001 5.61088 7.43056 5.76191L4.44076 9.25H2.75V4.10526ZM2.75 10.75V15.8947C2.75 16.6799 3.34543 17.25 4 17.25H16C16.6546 17.25 17.25 16.6799 17.25 15.8947V10.75H2.75ZM4 1.25C2.44543 1.25 1.25 2.56506 1.25 4.10526V15.8947C1.25 17.4349 2.44543 18.75 4 18.75H16C17.5546 18.75 18.75 17.4349 18.75 15.8947V4.10526C18.75 2.56506 17.5546 1.25 16 1.25H4ZM6 5C6 5.55228 5.55228 6 5 6C4.44772 6 4 5.55228 4 5C4 4.44772 4.44772 4 5 4C5.55228 4 6 4.44772 6 5ZM13.7653 9.25L11.6592 6.09085L10.286 8.10154C10.1658 8.27758 9.97634 8.39415 9.76501 8.4221C9.55367 8.45005 9.34043 8.38675 9.17857 8.24801L8.08135 7.30754L6.41638 9.25H13.7653Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default CoverImage
